import * as firebase from 'firebase';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormArray, FormBuilder } from '@angular/forms';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import { SpinnerService } from '@app/@shared/spinner/spinner.service';
import { UserService } from '@app/services/user.service';
import { CognitiveTestService } from '@app/services/cognitive-test.service';
import { ActivatedRoute } from '@angular/router';
import { CongnitiveTestType } from '@app/interface/common';
import { Constant } from '@app/@core';
import { StudiesService } from '@app/services/studies.service';
import { StudyModel } from '@app/interface/study.model';
import { UserGroupService } from '@app/services';
import { UserGroupModel } from '@app/interface/userGroup.model';
import { StudyAccessType } from '@app/@shared/enums';
import { of } from 'rxjs';
import { CognitiveTestTypeEnums } from '@app/@shared/enums/cognitive.enum';
import { ActiveStatus } from '@app/interface/common';

@Component({
  selector: 'app-add-cognitive',
  templateUrl: './addEditCognitive.component.html',
  styleUrls: ['./addEditCognitive.component.scss'],
})
export class AddEditCognitiveComponent implements OnInit {
  cognitiveFormGoNoGO: FormGroup;
  cognitiveFormPvt: FormGroup;
  cognitiveFormGambling: FormGroup;
  congnitiveTestTypeName = new FormControl('');
  wordPairsForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  cognitiveStatus: ActiveStatus[] = Constant.ActiveStatus;
  CognitiveTestType: CongnitiveTestType[] = [
    { value: 'go-no-go', name: CognitiveTestTypeEnums.NONOGO },
    { value: 'cognitive-pvt', name: CognitiveTestTypeEnums.COGNITIVETESTPVT },
    { value: 'gamblinf', name: CognitiveTestTypeEnums.GAMBLINGTEST },
    { value: 'word-pair-test', name: CognitiveTestTypeEnums.WORDPAIRTEST },
  ];
  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;

  studyDetail: StudyModel;
  userGroupsOptins: Array<UserGroupModel> = [];
  userGroups: Array<UserGroupModel> = [];
  checkCognitiveTestName: any;
  selectedQuestionType: string;
  selectTestForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private cognitiveTestService: CognitiveTestService,
    private studiesService: StudiesService,
    private userGroupServie: UserGroupService
  ) {}

  ngOnInit() {
    this.selectTestForm = this.formBuilder.group({
      testType: [],
    });
    this.createForm();
    this.getstudyDetail();
    this.getUserGroups();
  }

  get cognitiveGoNoGoFormControl() {
    return this.cognitiveFormGoNoGO.controls;
  }

  newPair(): FormGroup {
    return this.formBuilder.group({
      wordA: '',
      wordB: '',
    });
  }

  public addSkills(): void {
    this.wordPairs.push(this.newPair());
  }

  get wordPairs(): FormArray {
    return this.wordPairsForm.get('wordPairs') as FormArray;
  }

  private getstudyDetail(studyName?: string): void {
    this.studiesService.getStudyDetailById().subscribe((study: StudyModel) => {
      this.studyDetail = study;
      if (this.studyDetail?.studyAccessType === StudyAccessType.DEFAULT) {
        this.cognitiveFormGoNoGO.get('groupIds').clearValidators();
        this.cognitiveFormGoNoGO.get('groupIds').updateValueAndValidity();
        this.cognitiveFormPvt.get('groupIds').clearValidators();
        this.cognitiveFormPvt.get('groupIds').updateValueAndValidity();
        this.cognitiveFormGambling.get('groupIds').clearValidators();
        this.cognitiveFormGambling.get('groupIds').updateValueAndValidity();
        this.wordPairsForm.get('groupIds').clearValidators();
        this.wordPairsForm.get('groupIds').updateValueAndValidity();
      }
    });
  }

  public selectQuestionType(e: any): void {
    this.selectedQuestionType = e?.value ? e.value['name'] : e;
  }

  onChange(e: any) {
    this.checkCognitiveTestName = e?.value ? e.value['value'] : e;
  }

  private createForm(): void {
    this.cognitiveFormGoNoGO = this.formBuilder.group({
      cognitiveTestType: [],
      uuid: [],
      cognitiveTestName: ['', [Validators.required()]],
      cognitiveTestDescription: ['', [Validators.required()]],
      goNoGoDuration: ['', [Validators.required()]],
      noOfGoes: ['', [Validators.required()]],
      noOfNoGoes: ['', [Validators.required()]],
      errorMsgDuration: ['', [Validators.required()]],
      groupIds: [new Array(), [Validators.required()]],
      isActive: [false, [Validators.required()]],
    });

    this.cognitiveFormPvt = this.formBuilder.group({
      cognitiveTestType: [],
      uuid: [],
      cognitiveTestName: ['', [Validators.required()]],
      cognitiveTestDescription: ['', [Validators.required()]],
      testDurationPvt: ['', [Validators.required()]],
      eachTimerBetweenMinPvt: ['', [Validators.required()]],
      eachTimerBetweenMaxPvt: ['', [Validators.required()]],
      abortDurationPvt: ['', [Validators.required()]],
      groupIds: [new Array(), [Validators.required()]],
      isActive: [false, [Validators.required()]],
    });

    this.cognitiveFormGambling = this.formBuilder.group({
      cognitiveTestType: [],
      uuid: [],
      cognitiveTestName: ['', [Validators.required()]],
      cognitiveTestDescription: ['', [Validators.required()]],
      totalTrialGambling: ['', [Validators.required()]],
      initalAmoutGambling: ['', [Validators.required()]],
      noOfGainDecOne: ['', [Validators.required()]],
      noOfLossDecOne: ['', [Validators.required()]],
      noOfLossPercentageDecOne: ['', [Validators.required()]],
      noOfGainDecTwo: ['', [Validators.required()]],
      noOfLossDecTwo: ['', [Validators.required()]],
      noOfLossPercentageDecTwo: ['', [Validators.required()]],
      noOfGainDecThree: ['', [Validators.required()]],
      noOfLossDecThree: ['', [Validators.required()]],
      noOfLossPercentageDecThree: ['', [Validators.required()]],
      noOfGainDecFour: ['', [Validators.required()]],
      noOfLossDecFour: ['', [Validators.required()]],
      noOfLossPercentageDecFour: ['', [Validators.required()]],
      maxGameDurationGambling: ['', [Validators.required()]],
      groupIds: [new Array(), [Validators.required()]],
      isActive: [false, [Validators.required()]],
    });

    this.wordPairsForm = this.formBuilder.group({
      cognitiveTestType: [],
      uuid: [],
      cognitiveTestName: [''],
      cognitiveTestDescription: [''],
      wordPairs: this.formBuilder.array([]),
      durationDisplayWords: ['', [Validators.required()]],
      durationUserAnswer: ['', [Validators.required()]],
      passPercentage: ['', [Validators.required()]],
      totalNumberroundswordPair: ['', [Validators.required()]],
      groupIds: [new Array(), [Validators.required()]],
      isActive: [false, [Validators.required()]],
    });

    if (this.formType === 'Edit') {
      this.selectTestForm.get('testType').patchValue(this.form_data.cognitiveTestType);
      this.selectedQuestionType = this.form_data.cognitiveTestType;
      if (this.selectedQuestionType === 'go-no-go') {
        this.cognitiveFormGoNoGO.patchValue(this.form_data);
      } else if (this.selectedQuestionType === 'cognitive-pvt') {
        this.cognitiveFormPvt.patchValue(this.form_data);
      } else if (this.selectedQuestionType === 'gamblinf') {
        this.cognitiveFormGambling.patchValue(this.form_data);
      } else {
        this.wordPairsForm.patchValue(this.form_data);
        this.setSkills(this.form_data);
      }
    }
  }

  private setSkills(form_data: any): void {
    form_data.wordPairs.map(() => {
      this.addSkills();
    });
    this.wordPairs.patchValue(form_data.wordPairs);
  }

  public removeSkill(i: number): void {
    this.wordPairs.removeAt(i);
  }

  get goNoGoformControl() {
    return this.cognitiveFormGoNoGO.controls;
  }

  get pvtformControl() {
    return this.cognitiveFormPvt.controls;
  }

  get gamblingFormControl() {
    return this.cognitiveFormGambling.controls;
  }

  get wordPairsControl() {
    return this.wordPairsForm.controls;
  }

  public save(): void {
    this.submitted = true;
    if (this.cognitiveFormPvt.valid) {
      const cognitiveData = this.cognitiveFormPvt.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateCognitive(cognitiveData);
      } else {
        this.submitAddEditCognitive(cognitiveData);
      }
    } else if (this.cognitiveFormGoNoGO.valid) {
      const cognitiveData = this.cognitiveFormGoNoGO.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateCognitive(cognitiveData);
      } else {
        this.submitAddEditCognitive(cognitiveData);
      }
    } else if (this.cognitiveFormGambling.valid) {
      const cognitiveData = this.cognitiveFormGambling.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateCognitive(cognitiveData);
      } else {
        this.submitAddEditCognitive(cognitiveData);
      }
    } else if (this.wordPairsForm.valid) {
      const cognitiveData = this.wordPairsForm.value;
      this.isLoading = true;
      this.spinnerService.show();
      if (this.formType === 'Edit') {
        this.updateCognitive(cognitiveData);
      } else {
        this.submitAddEditCognitive(cognitiveData);
      }
    } else {
      return;
    }
  }

  private submitAddEditCognitive(cognitiveData: any): void {
    this.cognitiveTestService
      .addCognitive(cognitiveData, this.studyDetail, this.selectTestForm.get('testType').value)
      .subscribe(() => {
        this.isLoading = false;
        this.submitted = false;
        this.activeModal.close(true);
        this.spinnerService.hide();
      });
  }

  private updateCognitive(cognitiveData: any): void {
    this.cognitiveTestService.updateCognitive(cognitiveData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  private getRupteParmas(): void {
    this.studiesService.routeParams$.subscribe((params) => {
      if (params) {
        this.getstudyDetail(params.name);
      }
    });
  }

  private getUserGroups(): void {
    this.userGroupServie.getUserGroups().subscribe((userGroups: UserGroupModel[]) => {
      this.userGroupsOptins = userGroups;
      this.checkGroupIds();
    });
  }

  private checkGroupIds(): void {
    let studyId = this.studiesService.getStudyId();
    let groupIds = this.cognitiveFormGoNoGO.get('groupIds').value;
    if (groupIds && groupIds.length === 0) {
      let defaultGroup = this.userGroupsOptins.find((item) => item.studyId === studyId && item.isDefault === true);
      this.cognitiveFormGoNoGO.get('groupIds').patchValue([defaultGroup.uuid]);
    }
  }
}
